function SquareButton({ icon, onClick }) {
  // Take the price out of the text name
  return (
    <button className="w-8 h-8 flex justify-center items-center text-white p-0 border-0" onClick={onClick}>
      {icon}
    </button>
  );
}

export default SquareButton;